<div
  class="relative flex"
  [ngClass]="[(isOpen ? 'gap-4' : 'justify-center'), canAccess ? 'cursor-pointer' : 'cursor-not-allowed opacity-60']"
  (click)="onClick()"
>
  <div class="relative flex flex-col items-center">
    @if (lesson.status === lessonStatus.IN_PROGRESS) {
      <l-progress-ring [progress]="getLessonProgress()" size="sm" [showLabel]="false" />
    } @else {
      <span
        class="grid h-7 w-7 place-items-center rounded-full border text-xs"
        [ngClass]="lesson.status === lessonStatus.COMPLETED
          ? 'border-lSuccessSoft bg-lSuccessSoft text-white'
          : 'border-lGray700 bg-lGray700 text-lSecondary'"
      >
        <l-icon class="text-xs" [filled]="lesson.status !== lessonStatus.COMPLETED">{{ lessonIcon(lesson.status) }}</l-icon>
      </span>
    }

    @if (!isLast) {
      <span
        class="block h-9 w-[2px]"
        [ngClass]="lesson.status === lessonStatus.COMPLETED ? 'bg-lSuccessSoft' : 'bg-transparent'"
      ></span>
    }
  </div>

  @if (isOpen) {
    <div class="flex min-w-0 flex-1 items-start justify-between gap-3 pt-0.5">
      <p
        class="line-clamp-2 text-base leading-5"
        [ngClass]="isSelected || lesson.status === lessonStatus.IN_PROGRESS ? 'text-lPrimary' : 'text-lSecondary'"
      >
        {{ lesson.title }}
      </p>
      <span
        class="pt-0.5 text-sm"
        [ngClass]="isSelected || lesson.status === lessonStatus.IN_PROGRESS ? 'text-lPrimary' : 'text-lSecondary'"
      >
        {{ formatDuration(lesson.duration) }}
      </span>
    </div>
  }
</div>
